// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesEdu = {
  eduCourse: "课程",
  eduLearningRecord: "学习记录",
  eduMember: "EDU 成员",
  eduOrg: "EDU 组织",
  eduOverviewLearnerMessage: "学习者消息",
  eduProject: "项目实训",
  eduPublicCourse: "公开课程",
  eduTeachingPlan: "教学计划",
  eduAuth: "EDU 认证",
  eduOverview: "EDU 总览",
} as const;
